/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CollectionAddToIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Collection Add To',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 28h-6V18h6v-2h-6V6h8v8h2V6h8v8h2V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h17Zm-8 0H4V18h8Zm0-12H4V6h8Z"
    />
    <path
      d="m35.394 25.051-3.837-3.837 4.3-4.363A.5.5 0 0 0 35.5 16H22v13.494a.5.5 0 0 0 .854.358l4.33-4.265 3.837 3.837a1 1 0 0 0 1.414 0l2.96-2.959a1 1 0 0 0-.001-1.414Z"
    />
  </svg>`;
};
